import React, { useEffect, useState } from "react";
import { RootState } from "../../../../redux/rootReducers";
import { resetSession } from "../../../../redux/auth";
import { connect } from "react-redux";
import {
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
} from "../../../../redux/masterData";
import {
  addAutoUniqueNumberGenerationAction,
  getAutoUniqueNumberGenerationAction,
  resetAutoUniqueNumberGenerationData,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetMessage,
} from "../../../../redux/clientSettings";

import { ErrorSuccessModal, Loader, ToggleSwitch } from "../../../commons";
import { useParams } from "react-router-dom";

import toast, { Toaster } from "react-hot-toast";
import {
  AddAutoUniqueNumberPayloadType,
  GetAutoUniqueNumberPayloadType,
} from "../../../../commonTypes/clientSettingsTypes";
import "../style.scss"

type AppProps = {
  history: any;
  token: string | null;
  masterFetching: boolean;
  masterStatusCode: null | number;
  masterError: null | string;
  masterSuccess: null | number;
  masterMessage: string | null;
  menuName: string;
  success: null | number;
  fetching: boolean;
  error: null | string;
  statusCode: null | number;
  message: string | null;
  dispatchResetSession: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetClientSettingMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchAddAutoUniqueNumberAction: (
    data: AddAutoUniqueNumberPayloadType
  ) => void;
  dispatchGetAutoUniqueNumberCheckAction: (
    data: GetAutoUniqueNumberPayloadType
  ) => void;
  autoUniqueNumberGenerationData: any;
  dispatchResetAutoUniqueNumberGenerationData: () => void;
};

const UniqueNumber = ({
  history,
  token,
  masterFetching,
  masterStatusCode,
  masterError,
  masterSuccess,
  masterMessage,
  success,
  fetching,
  error,
  statusCode,
  message,
  menuName,
  dispatchResetSession,
  dispatchResetMasterSuccess,
  dispatchResetMasterError,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,
  dispatchResetClientSettingsSuccess,
  dispatchResetClientSettingMessage,
  dispatchResetClientSettingsError,
  dispatchAddAutoUniqueNumberAction,
  dispatchGetAutoUniqueNumberCheckAction,
  autoUniqueNumberGenerationData,
  dispatchResetAutoUniqueNumberGenerationData,
}: AppProps) => {
  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code;
  const [isAutoUniqueNumberCheck, setIsAutoUniqueNumberCheck] =
    useState<boolean>(false);
  const { id }: any = useParams();

  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetClientSettingMessage();
    dispatchResetMasterMessage();
    dispatchResetMasterStatusCode();
    dispatchResetClientSettingsSuccess();
    dispatchResetClientSettingsError();
    dispatchResetAutoUniqueNumberGenerationData();
    toast.dismiss();
    if (token) {
      let finalData = {
        token,
        clientCode: id,
        general_settings_type: "ledger_number",
      };
      dispatchGetAutoUniqueNumberCheckAction(finalData);
    }
    return () => {
      toast.dismiss();
    };
  }, []);

  useEffect(() => {
    if (
      autoUniqueNumberGenerationData &&
      Object.keys(autoUniqueNumberGenerationData)?.length > 0
    ) {
      setIsAutoUniqueNumberCheck(
        autoUniqueNumberGenerationData?.is_enable === 1
      );
    } else {
      setIsAutoUniqueNumberCheck(false);
    }
  }, [autoUniqueNumberGenerationData]);

  useEffect(() => {
    if (
      success === 1 &&
      message?.includes("General Settings has been updated successfully")
    ) {
      toast.success("Auto Unique Number updated successfully!", {
        duration: 3000,
      });
    }
  }, [success, message]);

  const handleUpdate = () => {
    let finalData = {
      token,
      clientCode: id,
      isAutoUniqueNumberCheck: isAutoUniqueNumberCheck ? 1 : 0,
      general_settings_type: "ledger_number",
    };

    dispatchAddAutoUniqueNumberAction(finalData);
    dispatchResetClientSettingMessage();
    dispatchResetClientSettingsSuccess();
  };

  const handleChangeAutoUniqueNumber = () => {
    setIsAutoUniqueNumberCheck(!isAutoUniqueNumberCheck);
  };

  const handleGoBack = () => {
    history?.push({
      pathname: `/client-settings/${id}`,
      state: { client_code, company_name },
    });
  };

  const handleErrorModal = () => {
    if (success === 0 || masterSuccess === 0) {
      dispatchResetMasterSuccess();
      if (statusCode === 401 || masterStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error || !!masterError}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode || masterStatusCode}
          />
        );
      } else if (
        (!!error || !!masterError) &&
        (statusCode !== 401 || masterStatusCode !== 401)
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error || !!masterError}
            title="Error"
            message={error || masterError}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
              dispatchResetMasterSuccess();
              dispatchResetMasterError();
              dispatchResetMasterMessage();
              dispatchResetMasterStatusCode();
              dispatchResetClientSettingsSuccess();
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }
    return false;
  };
  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div style={{ maxWidth: "78%" }}>
          <p className="pdf_template_header">{menuName}</p>
          <p className="sub_heading">
            Please enable Auto Unique Number settings if you want to use Auto
            Unique Number Generation.
          </p>
        </div>
      </div>
      <div className="hsn-check-main-container mb-4 mt-4">
        <label htmlFor="Stage" className="royaltyLabel ms-3">
         Do you require an auto-generation of unique numbers?
        </label>
        <div className="questions-toggle ms-3">
          <div className="toggleFilterMainDiv">
            <div className="toggleFilterInnerDiv">
              <ToggleSwitch
                handleToggleChange={() => handleChangeAutoUniqueNumber()}
                isChecked={isAutoUniqueNumberCheck}
                name="dailyVoucherFilter"
              />

              <span className="mt-1 toogleTextLabel hsn-check-toggle-title">
                {isAutoUniqueNumberCheck ? "Yes" : "No"}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="auto-unique-number-note">
        <div
          style={{
            display: "flex",
            gap: "10px",
            flexDirection: "column",
            lineHeight: "1.2",
            fontSize: "13px"
          }}
        >
          <span >Note</span>
          <span>Enabling this setting will automatically generate a unique number when adding or editing entries in the following modules:</span>
          <span>1. Business Address.</span>
          <span>2. Customer/Supplier.</span>
          <span>3. Account Manager.</span>

        </div>
      </div>
      <hr></hr>

      <div className="row">
        <div className="col-md-12 text-right">
          <button
            className="btn "
            style={{ border: "1px solid #bfcbe1", marginRight: "15px" }}
            onClick={() => handleGoBack()}
          >
            {"Cancel"}
          </button>
          <button
            className="btn btn-primary"
            onClick={handleUpdate}
          >
            {/* {editId ? "Update" : "Save"} */}
            Update
          </button>
        </div>
      </div>
      <div className="pdfImages mt-3">
        <Toaster />
        {fetching && <Loader />}
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  masterFetching: state.masterData.fetching,
  masterStatusCode: state.masterData.statusCode,
  masterError: state.masterData.error,
  masterSuccess: state.masterData.success,
  masterMessage: state.masterData.message,
  success: state.clientSettings.success,
  fetching: state.clientSettings.fetching,
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode,
  message: state.clientSettings.message,
  autoUniqueNumberGenerationData: state.clientSettings.autoUniqueNumberGenerationData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetClientSettingMessage: () => dispatch(resetMessage()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchAddAutoUniqueNumberAction: (data: AddAutoUniqueNumberPayloadType) =>
    dispatch(addAutoUniqueNumberGenerationAction(data)),
  dispatchGetAutoUniqueNumberCheckAction: (
    data: GetAutoUniqueNumberPayloadType
  ) => dispatch(getAutoUniqueNumberGenerationAction(data)),
  dispatchResetAutoUniqueNumberGenerationData: () =>
    dispatch(resetAutoUniqueNumberGenerationData()),

});

export default connect(mapStateToProps, mapDispatchToProps)(UniqueNumber);
